export default __webpack_public_path__ + "static/media/iconVoice.d8cf5324.svg";